import { fexGet } from "@/utils/fex"


export const getImages = async ()=>{
    const res = await fexGet("api/stock-images")
    return res
}